import { useState } from "react";
import { useParams } from "react-router-dom";
import { PostList } from "../components/PostList";
import { SpaceGroupList } from "../components/SpaceGroupList";
import { HelpWidgetLayout } from "../components/common/HelpWidgetLayout";
import { SearchBar } from "../components/common/SearchBar";

export const HelpPage = () => {
  const [searchText, setSearchText] = useState("");
  const { spaceId } = useParams<{ spaceId?: string }>();

  const shouldRenderPostList = searchText || spaceId;

  return (
    <HelpWidgetLayout className="scrollbar-hide h-full overflow-auto">
      <div className="px-5 pb-2 pt-5">
        <SearchBar searchText={searchText} setSearchText={setSearchText} />
      </div>
      {shouldRenderPostList ? (
        <PostList spaceId={spaceId} searchText={searchText} />
      ) : (
        <SpaceGroupList />
      )}
    </HelpWidgetLayout>
  );
};
